<script setup lang="ts">
defineProps({
  vertical: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <dd class="description-list--value" :class="{ 'is-vertical': vertical }">
    <slot />
  </dd>
</template>
